function normalize(value) {
  return String(value ?? '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim()
}

function includesQuery(source, query) {
  return normalize(source).includes(query)
}

export function matchesPart(part, query, field = 'all') {
  const q = normalize(query)
  if (!q) return true

  if (field === 'model') return includesQuery(part.model, q)
  if (field === 'manufacturer') return includesQuery(part.manufacturer, q)
  if (field === 'name') return includesQuery(part.name, q)
  if (field === 'category') return includesQuery(part.category, q)
  if (field === 'partCode') return includesQuery(part.partCode, q)

  return (
    includesQuery(part.model, q) ||
    includesQuery(part.manufacturer, q) ||
    includesQuery(part.name, q) ||
    includesQuery(part.category, q) ||
    includesQuery(part.partCode, q) ||
    includesQuery(part.description, q) ||
    includesQuery(part.specs, q)
  )
}

function modelScore(model, query) {
  const m = normalize(model)
  if (!query) return 0
  if (m === query) return 100
  if (m.startsWith(query)) return 80
  if (m.includes(query)) return 60
  return 0
}

export function sortPartsByModelRelevance(parts, query) {
  const q = normalize(query)
  if (!q) {
    return [...parts].sort((a, b) => a.model.localeCompare(b.model, 'ko'))
  }
  return [...parts].sort((a, b) => {
    const scoreDiff = modelScore(b.model, q) - modelScore(a.model, q)
    if (scoreDiff !== 0) return scoreDiff
    return a.model.localeCompare(b.model, 'ko')
  })
}

export function uniqueSorted(values) {
  return [...new Set(values.filter(Boolean))].sort((a, b) => a.localeCompare(b, 'ko'))
}

export function matchesTransaction(tx, query) {
  const q = normalize(query)
  if (!q) return true
  return (
    includesQuery(tx.model, q) ||
    includesQuery(tx.manufacturer, q) ||
    includesQuery(tx.name, q) ||
    includesQuery(tx.worker, q) ||
    includesQuery(tx.purpose, q) ||
    includesQuery(tx.partCode, q) ||
    includesQuery(tx.memo, q)
  )
}
